import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { ResponseData, ResponseDataTransaction } from '../nest-responses';

@Injectable()
export class SubscriptionProvider {
    private readonly service: string = 'subcription';
	private readonly model: string = 'subcription';

    constructor(
        private nestApiProvider: NestApiProvider,
    ) {
    }

    public synchronizeGreatdayToken(payload: any): Observable<ResponseData<any>> {
		const method: string = 'POST';
		const func: string = 'synchronizeGreatdayToken';
		const params: any = payload;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
	}

	public oldTransaction(): Observable<ResponseData<any>> {
		const method: string = 'POST';
		const func: string = 'oldTransaction';
		const params: any = {};
		// const urlParams: any = param;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body); 
	}

	public masterCompany(): Observable<ResponseData<any>> {
		const method: string = 'POST';
		const func: string = 'masterCountry';
		const params: any = {};
		// const urlParams: any = param;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
	}
	
	public optionAddOnProduct(): Observable<ResponseData<any>> {
		const method: string = 'POST';
		const func: string = 'getOptionAddOnProduct';
		const params: any = {};
		// const urlParams: any = param;
		const urlParams: any =  {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
	}

	public saveAddon(param): Observable<ResponseData<any>> {
		const method: string = 'POST';
		const func: string = 'saveAddOn';
		const params: any = param || {};
		// const urlParams: any = param;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
	}

	public dashboard(payload: any): Observable<ResponseData<any>> {
		const method: string = 'POST';
		const func: string = 'dashboard';
		const params: any = {};
		// const urlParams: any = param;
		const urlParams: any = payload || {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
	}
	
	public getSubscriptionHistory(param: any): Observable<ResponseData<any>> {
		const method: string = 'POST';
		const func: string = 'getHistoryList';
		const params: any = {};
		const urlParams: any = param;
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
	}
    
    public getSubscriptionMasterPeriod(param: any): Observable<ResponseData<any>> {
		const method: string = 'POST';
		const func: string = 'getSubscriptionMasterPeriod';
		const params: any = {};
		const urlParams: any = param;
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }
    
    public saveSubscription(payload: any): Observable<ResponseDataTransaction<any>> {
		const method: string = 'POST';
		const func: string = 'saveSubscription';
		const params: any = payload;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
		return this.nestApiProvider.request<ResponseDataTransaction<any>>(method, url, params, urlParams, body);
    }

}


// WEBPACK FOOTER //
// ./src/shared/nestjs/subscription/SubscriptionProvider.ts